import React, { useState, useEffect } from "react";
import { Plus, Trash2 } from "lucide-react";
import toast from "react-hot-toast";
import api from "../services/api";
import { Card, Input, Button, Label } from "../components/ui";

export default function TecnicosScreen() {
  const [tecnicos, setTecnicos] = useState([]);
  const [novoNome, setNovoNome] = useState("");

  useEffect(() => {
    carregar();
  }, []);

  const carregar = () => {
    api
      .get("/tecnicos")
      .then((res) => setTecnicos(res.data))
      .catch((err) => console.error(err));
  };

  const adicionar = async () => {
    if (!novoNome) return;
    try {
      await api.post("/tecnicos", { nome: novoNome });
      toast.success("Técnico cadastrado!");
      setNovoNome("");
      carregar();
    } catch (err) {
      toast.error("Erro ao adicionar técnico.");
    }
  };

  const deletar = async (id) => {
    try {
      await api.delete(`/tecnicos/${id}`);
      toast.success("Técnico removido.");
      carregar();
    } catch (err) {
      toast.error("Erro ao deletar técnico.");
    }
  };

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div>
        <h2 className="text-2xl font-bold tracking-tight text-slate-900">
          Técnicos
        </h2>
        <p className="text-slate-500">
          Cadastre os técnicos responsáveis pelas Ordens de Serviço.
        </p>
      </div>

      <Card className="p-6">
        <div className="flex flex-col sm:flex-row gap-3 mb-6 items-start sm:items-end">
          <div className="w-full sm:flex-1">
            <Label>Nome</Label>
            <Input
              placeholder="Insira o nome do técnico..."
              value={novoNome}
              onChange={(e) => setNovoNome(e.target.value)}
            />
          </div>
          <Button onClick={adicionar} className="w-full sm:w-auto">
            <Plus size={18} className="mr-2" /> Adicionar
          </Button>
        </div>

        <div className="space-y-2">
          {tecnicos.map((t) => (
            <div
              key={t.id}
              className="flex justify-between items-center p-3 bg-slate-50 border rounded-md"
            >
              <span className="font-medium text-slate-700 truncate mr-4">{t.nome}</span>
              <Button
                variant="destructive"
                className="h-8 px-2 shrink-0"
                onClick={() => deletar(t.id)}
              >
                <Trash2 size={16} />
              </Button>
            </div>
          ))}
          {tecnicos.length === 0 && (
            <p className="text-center text-slate-500 text-sm py-4">
              Nenhum técnico cadastrado.
            </p>
          )}
        </div>
      </Card>
    </div>
  );
}